module.exports = __webpack_public_path__ + "img/mirroring-screen.b2aebaa6.svg";